import React, { useState } from 'react';
import { Button, Input, message } from 'antd';
import { useAuth } from '../contexts/AuthContext';

const TestLogin = () => {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('admin123');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleLogin = async () => {
    setLoading(true);
    try {
      console.log('Calling login with:', username, password);
      const result = await login(username, password);
      console.log('Login result:', result);
      if (result.success) {
        message.success('登录成功');
      } else {
        message.error(result.message || '用户名或密码错误');
      }
    } catch (error) {
      console.error('登录异常:', error);
      message.error('登录失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: '#f0f2f5'
    }}>
      <div style={{ 
        background: 'white', 
        padding: '30px', 
        borderRadius: '8px', 
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        width: '400px'
      }}>
        <h2 style={{ textAlign: 'center', marginBottom: '24px' }}>测试登录</h2>
        
        <Input 
          placeholder="用户名" 
          value={username} 
          onChange={(e) => setUsername(e.target.value)}
          style={{ marginBottom: '16px' }}
        />
        
        <Input.Password 
          placeholder="密码" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)}
          style={{ marginBottom: '24px' }}
        />
        
        <Button 
          type="primary" 
          onClick={handleLogin} 
          loading={loading}
          style={{ width: '100%' }}
        >
          登录
        </Button>
      </div>
    </div>
  );
};

export default TestLogin;